import {
  SET_TARGET_REFERENCES
} from './mutationTypes';

import { setActionStatusError, setActionStatusSuccess, setActionStatusPending } from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_TARGET_REFERENCES](state, targetReferences) {
    state.targetReferences = targetReferences;
  }
};